module.exports = __webpack_public_path__ + "static/media/tex_me3.4581aebe.png";